import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-insight-card',
    templateUrl: './insight-card.component.html',
    styleUrls: ['./insight-card.component.scss'],
    animations: [
        trigger('panelContent', [
            state('hidden', style({
                height: '0',
                opacity: 0
            })),
            state('visible', style({
                height: '*',
                opacity: 1
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class InsightCardComponent implements OnInit {

    @Input() id: string;
    @Input() label: string;
    @Input() infoCircleTooltip: string;
    @Input() savable: boolean = false;
    @Input() saved: boolean = true;
    @Input() generateDisabled: boolean = true;
    @Input() isEmpty: boolean = true;
    @Input() isAiGenerating: boolean = false;
    @Input() isPromptGenerating: boolean = false;
    @Input() collapseOnCancel: boolean = true;
    @Input() preLabelIcon: boolean = false;
    @Input() ariaLabelledBy: string;
    @Input() showEdit: boolean = false;
    @Input() expanded: boolean = false;

    @Output() generate: EventEmitter<PointerEvent> = new EventEmitter<PointerEvent>();
    @Output() stopGeneration: EventEmitter<void> = new EventEmitter();
    @Output() save: EventEmitter<PointerEvent> = new EventEmitter<PointerEvent>();
    @Output() editPromptClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() expandedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    animating: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;

    @ViewChild('contentWrapper') contentWrapper: ElementRef;

    constructor() {}

    ngOnInit(): void {
        if (this.isEmpty) {
            this.changeExpanded(false);
        }
    }

    changeExpanded(open: boolean) {
        this.expanded = open;
        this.expandedChange.emit(this.expanded);
    }

    generateButtonClicked(): void {
        if (!this.generateDisabled && !this.isAiGenerating) {
            if (this.isEmpty) {
                if (!this.expanded) {
                    this.changeExpanded(true);
                    this.contentWrapper.nativeElement.style.display = 'block';
                    this.generate.emit();
                } else {
                    this.changeExpanded(false);
                }
            } else {
                this.toggle();
            }
        }
    }

    toggle(): void {
        if (this.animating) {
            return;
        }

        this.animating = true;
        this.changeExpanded(!this.expanded);

        this.contentWrapper.nativeElement.style.display = 'block';

        event.preventDefault();
    }

    onToggleDone() {
        this.animating = false;
        if (!this.expanded) {
            this.contentWrapper.nativeElement.style.display = 'none';
        }
    }

    stopButtonClicked(): void {
        if (this.collapseOnCancel) {
            this.toggle();
        }
        this.stopGeneration.emit();
    }

    saveButtonClicked(): void {
        this.save.emit();
    }

    editPrompt(): void {
        this.editPromptClicked.emit();
    }
}
